module.exports = __webpack_public_path__ + "static/img/qr3.e96f62b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr3.png
// module id = mbPo
// module chunks = 1